import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const setViewportUnits = () => { 
  // Get the viewport height and multiply by 1% to get a vh unit value
  const vh = window.innerHeight * 0.01;
  const vw = window.innerWidth * 0.01;
  
  // Set the values in custom properties to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--vw', `${vw}px`);
  
  // Calculate and set aspect ratio
  const aspectRatio = window.innerWidth / window.innerHeight;
  document.documentElement.style.setProperty('--aspect-ratio', aspectRatio);
  
  // Set a scaling factor for height-constrained viewports
  // This will be used to scale content down on shorter displays
  const baseHeight = 800; // Baseline height that works well on Mac
  const heightScale = Math.min(1, window.innerHeight / baseHeight);
  document.documentElement.style.setProperty('--height-scale', heightScale);
};

setViewportUnits(); // Initial call

// Set the height initially and on window resize
window.addEventListener('resize', setViewportUnits);
window.addEventListener('orientationchange', setViewportUnits);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
